<template>
  <main
    :style="[marketplaceInfo?.primaryColorCode ? `--primary-color:${marketplaceInfo?.primaryColorCode}` : '', marketplaceInfo?.fontFamily ? `font-family:${marketplaceInfo?.fontFamily}` : '']"
  >
    <router-view />
  </main>
</template>

<script>
import { mapGetters } from "vuex";
// import { onMessage } from "firebase/messaging";
// import { messaging } from "./firebase"; // Ensure you import your firebase.js file
// import requestNotificationPermission from "./firebaseMessaging";

export default {
  name: 'App',
  computed: {
    ...mapGetters(['marketplaceInfo'])
  },
  mounted() {
    // this.init();
  },
  methods: {
    // init() {
    //   // Request notification permission
    //   requestNotificationPermission();
    //   // Handle incoming messages in the foreground
    //   onMessage(messaging, (payload) => {
    //     // console.log("Foreground message received: ", payload);

    //     const notificationTitle = payload.data?.title || payload.notification?.title;
    //     const notificationBody = payload.data?.body || payload.notification?.body;
    //     // const notificationIcon = payload.data?.body || payload.notification?.icon;

    //     if (notificationTitle) {
    //       // Use moshaToast to display the notification
    //       this.$moshaToast(
    //           {
    //             title: notificationTitle,
    //             description: notificationBody
    //           },
    //           {
    //             type: 'info',
    //             showIcon: true
    //           }
    //       );
    //     }
    //   });
    // }
  }
};
</script>

<style lang="scss">
@tailwind base;

@tailwind components;

@tailwind utilities;
:root {
  --primary-color: #006295;
  @supports (accent-color: var(--primary-color)) {
    accent-color: var(--primary-color);
  }
}
@layer base {
  [type="text"]:focus,
  [type="email"]:focus,
  [type="url"]:focus,
  [type="password"]:focus,
  [type="number"]:focus,
  [type="date"]:focus,
  [type="datetime-local"]:focus,
  [type="month"]:focus,
  [type="search"]:focus,
  [type="tel"]:focus,
  [type="time"]:focus,
  [type="week"]:focus,
  [multiple]:focus,
  textarea:focus,
  select:focus {
    --tw-ring-color: var(--primary-color);
  }
}
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap");
@font-face {
  font-family: "Myriad Pro";
  src: url("./assets/fonts/MyriadPro-Regular.otf") format("opentype");
  font-display: swap;
}
@font-face {
  font-family: "Myriad Pro";
  font-weight: bold;
  src: url("./assets/fonts/MyriadPro-Bold.otf") format("opentype");
  font-display: swap;
}
@font-face {
  font-family: "Myriad Pro";
  font-weight: 600;
  src: url("./assets/fonts/MyriadPro-SemiBold.otf") format("opentype");
  font-display: swap;
}
@font-face {
  font-family: "Mangal";
  src: url("./assets/fonts/Mangal\ Regular.ttf") format("truetype");
  font-display: swap;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
input:invalid {
  box-shadow: none;
}
.bg-down-arrow {
  background-image: url("./assets/down-arrow.svg");
  background-position: 95% 50%;
  background-size: 0.75rem;
}
.bg-details-arrow {
  background-image: url("./assets/primary-arrow.svg");
  background-position: 95% 50%;
  &--modified {
    background-position: 98% 50%;
  }
}
details[open] {
  .bg-details-arrow {
    background-image: url("./assets/primary-down-arrow.svg");
  }
}
details summary::-webkit-details-marker {
  display: none;
}
.bg-nach-preview {
  background-image: url("./assets/nach-preview.jpg");
}
.bg-signup {
  background-image: url("./assets/sign-up.jpg");
}
form.errors {
  :invalid {
    border: 2px solid #dc2626;
  }
}
.input {
  @apply text-base px-3 py-1 rounded  border-primary border w-full placeholder-gray-300 focus:outline-none focus:ring  focus:border-primary disabled:bg-white  disabled:text-gray-400;
  &--w-16 {
    @apply w-16;
  }
  &--w-auto {
    @apply w-auto;
  }
  &--single {
    @apply text-center focus:bg-primary focus:text-white font-semibold w-10 border border-primary;
  }
  &--calenderCustomizePx {
    @apply px-1;
  }
}
.input_error {
  @apply text-base px-3 py-1 rounded  border-red-700 border w-full placeholder-gray-300 focus:outline-none focus:ring-red-700  focus:border-red-700 disabled:bg-white  disabled:text-gray-400;
  &--w-16 {
    @apply w-16;
  }
  &--w-auto {
    @apply w-auto;
  }
  &--single {
    @apply text-center focus:bg-red-700 focus:text-white font-semibold w-10 border border-red-700;
  }
}
.aadharInput {
  @apply text-base px-1 md:px-2  py-1 rounded  border-primary border w-full placeholder-gray-300 focus:outline-none  focus:border-primary disabled:bg-white  disabled:text-gray-400;
  &--w-16 {
    @apply w-16;
  }
  &--w-auto {
    @apply w-auto;
  }
  &--single {
    @apply text-center focus:bg-primary focus:text-white font-semibold w-6 border-2 md:w-8 border-primary;
  }
}
.input-file {
  @apply opacity-0 w-full h-10 cursor-pointer z-10 absolute;
}
.btn {
  @apply rounded  border-solid border flex  items-center justify-center focus:border-primary focus:ring  focus:outline-none relative;
  &--primary {
    @apply bg-primary text-white border-primary;
  }
  &--secondary {
    @apply bg-white text-primary border-primary;
  }
  &--white {
    @apply bg-white border-white text-primary;
  }
  &--lightGray {
    @apply bg-gray-300 border-gray-300 text-gray-400;
  }
  &--error {
    @apply bg-white border-white text-errorColor;
  }
  &:disabled {
    @apply opacity-50 cursor-not-allowed;
  }
  &--normal {
    @apply md:px-8 py-2 px-4;
  }
  &--average {
    @apply py-2 px-4;
  }
  &--small {
    @apply px-4 py-1 text-sm;
  }
}
.dropdown {
  @apply bg-white  rounded appearance-none min-w-64 text-base focus:outline-none focus:ring   focus:border-primary  border-none;
  &:required:invalid {
    @apply text-gray-300;
  }
  option {
    @apply text-textPrimary;
  }
  option[value=""][disabled] {
    display: none;
  }
}
.grey-layout {
  grid-template-rows: auto 1fr;
  @apply bg-greyBackground col-span-full w-full md:py-8 md:px-8 grid content-start gap-4 p-4 relative;
  &--increase-gap {
    @apply gap-8;
  }
}
.home-sidebar {
  grid-template-rows: auto 1fr auto;
  @apply overflow-hidden col-span-1 md:grid justify-items-center bg-greyBackground w-full content-start sticky top-0 hidden h-screen;
}
.label {
  @apply grid gap-1 text-gray-600 text-xs;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.word-wrap {
  word-wrap: anywhere;
}
.boxShadow {
    box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.01), 0 2px 0px 0 rgba(0, 0, 0, 0.06);
}
.nav-height{
  max-height: 90px;
}
.dot {
  @apply bg-primary;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
}

// * {
//   border: 1px solid red;
// }
.blink_me {
    // animation: blinker 1s linear infinite;
    display: inline-block;
    width: 5px;
    overflow: hidden;
    vertical-align: bottom;
    animation: blink_me 2s linear infinite;
    transition: 1;
}
@keyframes blink_me {
    from {
        width: 0px;
    }
    to {
        width: 25px
    }
}
.bg-down-butterfly {
  background-image: url("./assets/right-down-butterfly.svg");
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: 115px 140px;
}
</style>
